import { useState } from "react";
import Articleimg_04 from "../images/Articleimg_04.png"
import youtube_start from "../images/youtube_start.png"

const YTubeOrg = () => {
  const youtubeId:string = "rCslPLFeiuc";
  const [isThumbnail, setIsThumbnail] = useState(false);

  const youtube_thumnail = (flag: boolean) => {
      setIsThumbnail(flag);
      console.log(flag);
  }

  return (
    <>
      <iframe
        src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1`}
        title="刷毛引き本染め職人 吉田 健太 | 明日への扉 by アットホーム"
        frameBorder="0"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
      <div className={isThumbnail === true ? "hide-thumnail" : "view-thumnail"}>
        {/* <img src={youtube_start} onClick={() => youtube_thumnail(true)} className="youtube-start" alt="start button"/> */}
        <img src={Articleimg_04} onClick={() => youtube_thumnail(true)} alt='サムネイル' />
      </div>
    </>
  );
}

export default YTubeOrg;
